import {
  executeQuery,
  executeMutation
} from '@/common/service'
import {
  uploadUserDesignMutation,
  createDesignMutation,
  fullColorProductsByCategoryQuery,
  initStockLibraryQuery,
  productDetailQuery,
  categoryEditPatternQuery,
  productSkuEditPatternsQuery,
  crossSellDataQuery
} from '@/stockLibrary/queries'
import {
  CreateUserDesignInput,
  UploadUserDesignInput
} from '@/types/graphqlQuery'
import { ProductByCategoryVariables } from '@/stockLibrary/queries/types/index'
import { apolloUploadClient } from '@/common/service/apolloClient'

export const uploadUserDesign = async (
  input: UploadUserDesignInput,
  signal?: AbortSignal
) => {
  const response = await apolloUploadClient.mutate({
    mutation: uploadUserDesignMutation,
    variables: { input: input },
    context: { fetchOptions: { signal } }
  }).catch(err => {
    throw err
  })
  if (response?.errors) return null
  return response?.data?.uploadUserDesign
}

export const createUserDesign = (input: CreateUserDesignInput) => {
  return executeMutation(createDesignMutation, input)
}

export const getInitStockLibraryData = () => {
  return executeQuery(initStockLibraryQuery)
}

export const getCrossSellData = () => {
  return executeQuery(crossSellDataQuery)
}

export const getProductsByCategory = (variables: ProductByCategoryVariables) => {
  return executeQuery(fullColorProductsByCategoryQuery, variables)
}

export const getProductDetail = (productId: string) => {
  return executeQuery(productDetailQuery, { id: productId })
}

export const getCategoryEditPatterns = (categoryId: string) => {
  return executeQuery(categoryEditPatternQuery, { categoryId })
}

export const getProductEditPatternsByFirstOption = (productId: string, firstOption: string) => {
  return executeQuery(productSkuEditPatternsQuery, { id: productId, firstOption })
}
